import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-orders-copy-container-item-form',
  templateUrl: './orders-copy-container-item-form.component.html',
  styleUrls: ['./orders-copy-container-item-form.component.scss']
})
export class OrdersCopyContainerItemFormComponent implements OnInit {

  copyItemData: any;
  isFormLoading = false;
  quantity: number;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<OrdersCopyContainerItemFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MatDialog,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.copyItemData = this.data;
  }

  onSave() {
    if (this.quantity === 0) {
      this.toastr.error(`Invalid input.`);
    } else {
      const sendingData = {
        confirmResult: true,
        quantity: this.quantity
      };
      this.dialogRef.close(sendingData);
    }
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
